import React from 'react'
import { M_Table } from 'src/M_Components'

const currency = ({ roles }) => {
  return (
    <M_Table entityName={'currency'} rolePermissions={roles} />
  )
}

export default currency